"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInputChecked = void 0;
const react_1 = __importStar(require("react"));
const object_path_1 = __importDefault(require("object-path"));
const classnames_1 = __importDefault(require("classnames"));
const helpers_1 = require("../../lib/helpers");
const Radio_1 = require("./Radio");
const useToggleableChange_1 = require("../../hooks/useToggleableChange");
const FormContext_1 = require("../../contexts/FormContext");
const InputDiv_1 = __importDefault(require("./Base/InputDiv"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const useInputForm_1 = require("../../hooks/useInputForm");
const InputError_1 = __importDefault(require("./Base/InputError"));
const InputLabel_1 = require("./Base/InputLabel");
const useInputChecked = (props) => {
    var _a;
    const { formData } = react_1.useContext(FormContext_1.FormContext);
    if (props.checked !== undefined) {
        return props.checked;
    }
    if (props.name) {
        const currentFormValue = object_path_1.default.get(formData, props.name);
        const checkedValue = (_a = props.checkedValue) !== null && _a !== void 0 ? _a : true;
        // if (props.checkedValue !== undefined) {
        return helpers_1.isSameCheckedValue(currentFormValue, checkedValue);
        // }
        //
        // /* Cant do a value === undefined because <RadioInput needs the value="my-value"/> */
        // if (props.value) {
        //   if (Array.isArray(currentFormValue)) {
        //     return currentFormValue.includes(props.value)
        //   }
        //
        //   return currentFormValue === props.value
        // }
    }
    return false;
};
exports.useInputChecked = useInputChecked;
const RadioInput = (props) => {
    const { checkedValue, uncheckedValue } = props;
    const onChange = useInputForm_1.useInputFormChange(props);
    const toggleableProps = useToggleableChange_1.useToggleableChange(onChange, props.onClick, props.disabled);
    const isChecked = exports.useInputChecked(props);
    const label = InputLabel_1.getInputLabel(props.label, props.name);
    return (react_1.default.createElement(InputDiv_1.default, Object.assign({ value: props.value, error: props.error, className: classnames_1.default(props.className, { disabled: props.disabled }), label: props.label, name: props.name }, toggleableProps),
        react_1.default.createElement(Radio_1.Radio, Object.assign({}, helpers_1.without(props, ['className']), { checkedValue: checkedValue, uncheckedValue: uncheckedValue, checked: isChecked })),
        label && react_1.default.createElement("span", { className: "j-radio-input-label" }, label),
        react_1.default.createElement(InputError_1.default, null)));
};
exports.default = withJourney_1.default('j-radio-input', RadioInput);
